import { DEFAULT_OPTIONS } from '../constants';

/** @description Определение текущих настроек в зависимости от ширины контейнера
 * @param {number} width ширина контейнерав пикселях
 * @param {IMedia[]} media массив настроек
 * @return {IFullscreenCarouselOptions}
 */
export function getCurrentOptions(width, media) {
  var currentMedia = media.find(function (item) {
    return item.minWidth <= width && item.maxWidth > width;
  });
  return currentMedia ? currentMedia.options : DEFAULT_OPTIONS;
}